export const environment = {
  production: false,
  apiBaseUrl: 'https://api.dev.forknfind.com',
  webSocketUrl: 'wss://api.dev.forknfind.com',
  /**
   * Gateway API version for api.* calls (FNF-259). `v2` is served by Kong in
   * dev and staging (QA); prod must stay on `v1` until Kong serves it there.
   */
  apiVersion: 'v2',
  apiKey: 'c9ee48eb-062d-4109-8a26-72e1df1ce50d',
  posthogKey: 'phc_yC4dAV74AzDmKSumRb7wovro67YTWgDRj5arGqbj2ACx',
  posthogHost: 'https://us.i.posthog.com',
  /**
   * Firebase web app for the dashboard's push channel (FNF-415). Registered in
   * the forknfind-dashboard-dev project; empty values switch web push off rather
   * than failing, so a build without them still runs.
   */
  firebase: {
    apiKey: 'AIzaSyCw7OXs6cCWh8ajgI_OFjeeDyFckrt-idA',
    authDomain: 'forknfind-dashboard-dev.firebaseapp.com',
    projectId: 'forknfind-dashboard-dev',
    messagingSenderId: '458687048759',
    appId: '1:458687048759:web:f233348a113e246eb823b2',
  },
  /** Web Push certificate (VAPID public key) from the same project. */
  firebaseVapidKey:
    'BMIM0bB4id2xY5C683Zo56DzplAQ0HTXch8ZWO59B7ureEEb8IqOvWG9bsrg3g802W4ytGE0htfKOeqARfrE6kE',
};
